import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const NoRunnersStyled = styled.div({
  fontSize: '1.2rem',
  fontStyle: 'italic',
  color: hexColors.grey,
  textAlign: 'center',
})
